export default {
  basicViewItem: [{
    prop: 'id',
    label: '',
    Object: 'value'
  }, {
    prop: 'status',
    label: '',
    Object: 'value'
  }, {
    prop: 'supplier',
    label: '',
    Object: 'value'
  }, {
    prop: 'quantities',
    label: '',
    Object: 'value'
  }, {
    prop: 'remarks',
    label: '',
    Object: 'value'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value'
  }]
}
